export default __webpack_public_path__ + "static/media/battle_loading.fb2313b2.jpg";